import { Box, Heading, VStack, Text } from "@chakra-ui/react"
import Proyecto from "./Proyecto"
import LazyItem from "./LazyItem"
import anonymouspc from "../images/APC.png"
import portafolioImg from "../images/portafolio_vanila.png"
import avatarBot from "../images/avatar_bot.png"
import { useContext } from "react"
import { ThemeContext } from "../context/ThemeContext"
import { LanguageContext } from "../context/LanguageContext"

const Projects = () => {
    const {theme} = useContext(ThemeContext)
    const { t } = useContext(LanguageContext)
    
    const getProjects = () => {
        const proyectosWeb = [
            {
                img: anonymouspc,
                title: t('projects.webProjects.anonymouspc.title'),
                url: "https://anonymouspc.net/",
                description: t('projects.webProjects.anonymouspc.description'),
                technologies: ["React", "Node.js", "PostgreSQL", "Payment Gateway"]
            },
            {
                img: portafolioImg,
                title: t('projects.webProjects.dashboard.title'),
                url: "https://chatutelvt.pages.dev/",
                description: t('projects.webProjects.dashboard.description'),
                technologies: ["React", "Python", "PostgreSQL", "N8n", "Docker"]
            },
            {
                img: avatarBot,
                title: t('projects.webProjects.chatbot.title'),
                url: "https://chatutelvt.pages.dev/",
                description: t('projects.webProjects.chatbot.description'),
                technologies: ["Python", "LangChain", "RAG", "LLM Open Source", "Vector Database", "FastAPI"]
            }
        ]

        const proyectosIoT = [
            {
                img: portafolioImg,
                title: t('projects.iotProjects.smartLighting.title'),
                url: "https://github.com/Henry-GC/Iluminaria-inteligente-ESP32",
                description: t('projects.iotProjects.smartLighting.description'),
                technologies: ["ESP32", "Sensor LDR", "Sensor PIR", "Relé", "C++", "Arduino IDE"],
                fullDescription: t('projects.iotProjects.smartLighting.fullDescription'),
                hasModal: true
            },
            {
                img: portafolioImg,
                title: t('projects.iotProjects.accessControl.title'),
                url: "https://github.com/Henry-GC/Control-de-acceso-con-ESP32-huella-y-RFID",
                description: t('projects.iotProjects.accessControl.description'),
                technologies: ["ESP32", "Sensor R307", "Lector RC522", "RFID", "Electroimán", "Google Sheets"],
                fullDescription: t('projects.iotProjects.accessControl.fullDescription'),
                hasModal: true
            },
            {
                img: portafolioImg,
                title: t('projects.iotProjects.surgeProtector.title'),
                url: "https://github.com/Henry-GC/Detector-sobrevoltaje-ESP32",
                description: t('projects.iotProjects.surgeProtector.description'),
                technologies: ["ESP32", "Sensor ZMPT101B", "Relé", "EEPROM", "C++", "Arduino IDE"],
                fullDescription: t('projects.iotProjects.surgeProtector.fullDescription'),
                hasModal: true
            },
            {
                img: portafolioImg,
                title: t('projects.iotProjects.solarCharger.title'),
                url: "#",
                description: t('projects.iotProjects.solarCharger.description'),
                technologies: ["ESP32", "Paneles Solares", "LDR", "Servomotor", "Controlador de Carga", "LCD"],
                fullDescription: t('projects.iotProjects.solarCharger.fullDescription'),
                hasModal: true
            },
            {
                img: portafolioImg,
                title: t('projects.iotProjects.powerFactorCalculator.title'),
                url: "#",
                description: t('projects.iotProjects.powerFactorCalculator.description'),
                technologies: ["ESP32", "ACS712", "ZMPT101B", "LCD 16x2", "Cruce por Cero", "C++"],
                fullDescription: t('projects.iotProjects.powerFactorCalculator.fullDescription'),
                hasModal: true
            },
            {
                img: portafolioImg,
                title: t('projects.iotProjects.prepaidEnergyManager.title'),
                url: "#",
                description: t('projects.iotProjects.prepaidEnergyManager.description'),
                technologies: ["ESP32", "HLW8012", "RC522", "RFID", "Relé", "LCD", "Wi-Fi"],
                fullDescription: t('projects.iotProjects.prepaidEnergyManager.fullDescription'),
                hasModal: true
            }
        ]

        return { proyectosWeb, proyectosIoT }
    }

    const { proyectosWeb, proyectosIoT } = getProjects()
    return (
        <Box
            background={theme.bg.proyectos}
            transitionProperty="background" 
            transitionDuration="0.3s"
        >
            <Box
                display="flex"
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
                color={theme.color}
                transitionProperty="color" 
                transitionDuration="0.3s"
                padding="5%"
            >
                <Heading
                    as="h1" 
                    id="proyects"
                    fontSize={["2.5rem", "3rem", "3.5rem"]}
                    alignSelf="self-start"
                    marginBottom="3rem"
                    textAlign="center"
                    width="100%"
                >
                    {t('projects.title')}
                </Heading>

                {/* Sección Proyectos Web */}
                <VStack spacing="2rem" width="100%" marginBottom="4rem">
                    <Box textAlign="center" marginBottom="2rem">
                        <Heading
                            as="h2"
                            fontSize={["2rem", "2.2rem", "2.5rem"]}
                            color={theme.color}
                            marginBottom="0.5rem"
                            fontWeight="700"
                        >
                            {t('projects.webSection.title')}
                        </Heading>
                        <Text 
                            fontSize={["1rem", "1.1rem", "1.2rem"]}
                            color={theme.color}
                            opacity="0.8"
                            maxWidth="600px"
                            margin="0 auto"
                        >
                            {t('projects.webSection.subtitle')}
                        </Text>
                    </Box>
                    
                    <Box
                        display="grid"
                        gridTemplateColumns={["1fr", "1fr 1fr", "1fr 1fr 1fr"]}
                        gap="2rem"
                        width="100%"
                        justifyItems="center"
                    >
                        {proyectosWeb.map((proyecto, index)=>(
                            <LazyItem key={proyecto.title} index={index} delay={0.2}>
                                <Proyecto
                                    img={proyecto.img}
                                    title={proyecto.title}
                                    description={proyecto.description}
                                    url={proyecto.url}
                                    technologies={proyecto.technologies}
                                />
                            </LazyItem>
                        ))}
                    </Box>
                </VStack>

                {/* Sección Proyectos IoT */}
                <VStack spacing="2rem" width="100%">
                    <Box textAlign="center" marginBottom="2rem">
                        <Heading
                            as="h2"
                            fontSize={["2rem", "2.2rem", "2.5rem"]}
                            color={theme.color}
                            marginBottom="0.5rem"
                            fontWeight="700"
                        >
                            {t('projects.iotSection.title')}
                        </Heading>
                        <Text 
                            fontSize={["1rem", "1.1rem", "1.2rem"]}
                            color={theme.color}
                            opacity="0.8"
                            maxWidth="600px"
                            margin="0 auto"
                        >
                            {t('projects.iotSection.subtitle')}
                        </Text>
                    </Box>
                    
                    <Box
                        display="grid"
                        gridTemplateColumns={["1fr", "1fr 1fr", "1fr 1fr 1fr"]}
                        gap="2rem"
                        width="100%"
                        justifyItems="center"
                    >
                        {proyectosIoT.map((proyecto, index)=>(
                            <LazyItem key={proyecto.title} index={index + proyectosWeb.length} delay={0.2}>
                                <Proyecto
                                    img={proyecto.img}
                                    title={proyecto.title}
                                    description={proyecto.description}
                                    url={proyecto.url}
                                    technologies={proyecto.technologies}
                                    hasModal={proyecto.hasModal}
                                    fullDescription={proyecto.fullDescription}
                                />
                            </LazyItem>
                        ))}
                    </Box>
                </VStack>
            </Box>
        </Box>
    )
}

export default Projects